import React from 'react';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import { Loader2, Zap } from 'lucide-react';

interface ThemeMascotProps {
  category?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeConfig = {
  sm: { outer: 'h-8 w-8', zap: 'w-3.5 h-3.5' },
  md: { outer: 'h-12 w-12', zap: 'w-5 h-5' },
  lg: { outer: 'h-16 w-16', zap: 'w-7 h-7' },
};

export function ThemeMascot({
  size = 'md',
  className
}: ThemeMascotProps) {
  const config = sizeConfig[size];

  return (
    <div className={cn(config.outer, "relative flex items-center justify-center", className)}>
      <Loader2 className="w-full h-full animate-spin text-primary" />
      <Zap className={cn(config.zap, "absolute text-primary fill-primary/20")} />
    </div>
  );
}

interface LoadingWithMascotProps {
  category?: string;
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function LoadingWithMascot({
  message = 'Loading...',
  size = 'md'
}: LoadingWithMascotProps) {
  const config = sizeConfig[size];

  return (
    <div className="flex flex-col items-center justify-center p-6">
      <div className={cn(config.outer, "relative flex items-center justify-center")}>
        <Loader2 className="w-full h-full animate-spin text-primary" />
        <Zap className={cn(config.zap, "absolute text-primary fill-primary/20")} />
      </div>

      {message && (
        <motion.p
          className="mt-4 text-center text-muted-foreground"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          {message}
        </motion.p>
      )}
    </div>
  );
}
